import axios from "axios";
import { featureFlagsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { OfrepFlagsMap } from "../entities/ofrep-flags-map";

interface OfrepFlagResult {
  key: string;
  value: boolean | string;
}

interface OfrepEvaluateResponse {
  flags: OfrepFlagResult[];
}

export interface FetchFeatureFlagsParams {
  targetingKey: string;
  namespaceUuid: string;
  email: string;
}

/**
 * Fetches all feature flags via the GO Feature Flag relay's OFREP bulk
 * evaluate endpoint.
 *
 * Expected response shape: { flags: [ { key: "showDashboard", value: true }, ... ] }
 */
export const fetchFeatureFlags = async ({
  targetingKey,
  namespaceUuid,
  email,
}: FetchFeatureFlagsParams): Promise<OfrepFlagsMap> => {
  const response = await axios.post<OfrepEvaluateResponse>(
    `${featureFlagsUrlEnvVar()}/ofrep/v1/evaluate/flags`,
    {
      context: {
        targetingKey,
        namespace_uuid: namespaceUuid,
        email,
      },
    },
    { headers: buildAxiosAuthenticationHeaders() },
  );

  const flags: OfrepFlagsMap = {};
  for (const flag of response.data.flags ?? []) {
    flags[flag.key] = flag.value;
  }
  return flags;
};
